const USER_ID_KEY = 'user_id';

const AuthManager = {
  getAnonymousUserId(): string | null {
    return localStorage.getItem(USER_ID_KEY);
  },

  setAnonymousUserIfNotExists(userId: string): string {
    const existing = localStorage.getItem(USER_ID_KEY);
    if (!existing) {
      localStorage.setItem(USER_ID_KEY, userId);
    }
    return userId;
  },

  removeAnonymousUserId(): void {
    localStorage.removeItem(USER_ID_KEY);
  },
};

export default AuthManager;
